import React from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import LoginController from '../controllers/LoginController';
import SignupController from '../controllers/SignupController';
import ForgotPaswordController from '../controllers/ForgotPaswordController';
import VerifyRegisterOpt from '../controllers/VerifyRegisterOtp';
import LandingController from '../controllers/LandingController';
import IntegrationRequested from '../view/Signup/IntegrationRequested';

export default function PublicRoutes() {
      const location = useLocation();
    return (
        <Routes>
            <Route path="/" element={<LandingController />} />
            <Route path="/login" element={<LoginController />} />
            <Route path="/signup" element={<SignupController />} />
            <Route path="/verify" element={<VerifyRegisterOpt />} />
            <Route path="/integration-requested" element={<IntegrationRequested />} />
            <Route path="/forgot-password" element={<ForgotPaswordController view="forgot" />} />
            <Route path="/reset-password/:token" element={<ForgotPaswordController view="reset" />} />
            {/* <Route path="*" element={<LoginController />} /> */}
            <Route
                path="*"
                element={
                    <Navigate
                        to="/login"
                        replace
                        state={{ from: location }}
                    />
                }
            />
        </Routes>
    )

}